import React from 'react';
interface NavigationProps {
  currentView: string;
  onNavigate: (view: string) => void;
}
const NAV_ITEMS = [{
  id: 'home',
  label: 'Home'
}, {
  id: 'protocols',
  label: 'All Protocols'
}, {
  id: 'technique',
  label: 'Needling Technique'
}, {
  id: 'about',
  label: 'About Dr. Jin'
}];
export function Navigation({
  currentView,
  onNavigate
}: NavigationProps) {
  return <nav className="bg-[#FAF8F6] px-4 py-4 border-b border-[#E5E7EB]" data-id="element-47">
      <div className="max-w-6xl mx-auto" data-id="element-48">
        <div className="flex flex-wrap gap-2" data-id="element-49">
          {NAV_ITEMS.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`
                px-4 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${currentView === item.id ? 'bg-[#8B1538] text-white shadow-sm' : 'bg-white text-gray-700 border border-gray-200 hover:border-[#FECACA] hover:text-[#8B1538]'}
              `} data-id="element-50">
              {item.label}
            </button>)}
        </div>
      </div>
    </nav>;
}